import { useEffect, useState } from "react";
import { ChevronLeftIcon, ChevronRightIcon } from "@heroicons/react/24/outline";

import { useResponsive } from "../../hooks/useResponsive.js";
import {
  BASE_GAP,
  SCROLL_BY_ONE_MULTIPLIER,
} from "../../services/lib/constants.js";

function ButtonsPreview({ ribbon, length, isScrollByOne = false }) {
  const { isLG } = useResponsive();
  const [isDesktopDevice, setIsDesktopDevice] = useState(true);

  useEffect(() => {
    const detectDevice = () => {
      if (typeof navigator === "undefined") {
        setIsDesktopDevice(true);
        return;
      }

      const ua = navigator.userAgent || navigator.vendor || "";
      const lowerUA = ua.toLowerCase();

      const isIpadOS13 =
        lowerUA.includes("macintosh") &&
        typeof navigator.maxTouchPoints === "number" &&
        navigator.maxTouchPoints > 1;

      const isMobile = /(android|iphone|ipod|blackberry|windows phone|mobile)/i.test(ua);
      const isTablet = /(ipad|tablet|playbook|silk|kindle)/i.test(ua) || isIpadOS13;

      setIsDesktopDevice(!(isMobile || isTablet));
    };

    detectDevice();
  }, []);

  const scrollByOne = (direction) => {
    const step = ribbon.current?.scrollWidth / length;
    if (ribbon.current) {
      ribbon.current.scrollBy({
        left: (direction === "left" ? -step : step) * SCROLL_BY_ONE_MULTIPLIER,
        behavior: "smooth",
      });
    }
  };

  const scrollBySet = (direction) => {
    if (ribbon.current) {
      const ribbonWidth = ribbon.current.offsetWidth;
      ribbon.current.scrollBy({
        left:
          direction === "left"
            ? isLG
              ? -ribbonWidth - BASE_GAP
              : (-ribbonWidth - BASE_GAP) / 2
            : isLG
            ? ribbonWidth + BASE_GAP
            : (ribbonWidth + BASE_GAP) / 2,
        behavior: "smooth",
      });
    }
  };

  const scrollType = isScrollByOne ? scrollByOne : scrollBySet;

  if (isLG || !isDesktopDevice) return null;

  return (
    <div className="absolute z-10 -top-[0.65rem] -translate-y-full flex gap-4 pl-16 pr-8 py-2 bg-buttons-wrapper-gradient right-0">
      <ButtonsPreviewArrow dir="left" clickHandler={scrollType} />
      <ButtonsPreviewArrow dir="right" clickHandler={scrollType} />
    </div>
  );
}

export default ButtonsPreview;

function ButtonsPreviewArrow({ dir, clickHandler }) {
  return (
    <button
      className="cursor-pointer w-12 md:w-16 hover:text-red-500 transition-colors duration-300"
      onClick={() => clickHandler(dir)}
      aria-label={`Scroll ${dir}`}
    >
      {dir === "left" ? <ChevronLeftIcon /> : <ChevronRightIcon />}
    </button>
  );
}
